import React from "react";
import moment from 'moment';
import ReactTable from "react-table";
import SweetAlert from 'react-bootstrap-sweetalert'
import EmailButton from 'components/CustomButtons/EmailButton'
import UserButton from "./CustomButtons/UserButton";

function RemoveButton(props) {

    const [alert, setAlert] = React.useState(false)
    function confirmRemove() {
        if (props.remove) {
            props.remove()
            setAlert(false)
        }
    }

    function handleClick() {
        // setShow(true)
        setAlert(<SweetAlert
            // warning
            showCancel
            confirmBtnText="Remove"
            confirmBtnBsStyle="danger"
            title="Removing client"
            onConfirm={() => confirmRemove()}
            onCancel={() => setAlert(null)}
            focusCancelBtn
            >
             Are you sure you want to remove this client?
            </SweetAlert>)
    }

    const [show, setShow] = React.useState(false);

    return (
        <div className="d-flex justify-content-end">
            {alert}
            {/* <Modal show={show} onHide={() => setShow(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Removing client</Modal.Title>
                </Modal.Header>
            
                <Modal.Body>
                    <p>Are you sure you want to remove this client?</p>
                </Modal.Body>
            
                <Modal.Footer>
                    <Button onClick={() => setShow(false)} variant="secondary">Cancel</Button>
                    <Button onClick={confirmRemove} variant="danger">Remove Client</Button>
                </Modal.Footer>
            </Modal> */}

            <button onClick={handleClick} type="button" className="btn btn-link _danger">
                Remove
            </button>
        </div>
    );
}

function ClientTable(props) {

    let {clients, blockList} = props;

    const handleRemoveClient = (val) => {
        if (props.handleRemoveClient) {
            props.handleRemoveClient(val)
        }
    }

    clients = clients.map(val => {
        let actions = (
            <EmailButton 
                email={val.email}
            />
        )
        let marketingOptInBubble = (
            <div className="marketingOptInBubble"
            style={{
                backgroundColor: (val.marketingOptIn ? "#dae8cc" : "#fbeeca"),
                textAlign: "center",
                width: "120px",
                height: "24px",
                borderRadius: "12px"
            }}>
                {val.marketingOptIn ? "Subscribed" : "Unsubscribed"}
            </div>
        )
        let buttonToUser = (
            <UserButton 
            user={val}
            />
        )
        return {
            ...val,
            user: {...val},
            marketingOptInBubble,
            actions,
            buttonToUser
        }
    })

    let tableColumns = [
        {
            Header: "Name",
            accessor: "user",
            sortable: true,
            sortMethod: (a,b) => a.firstName > b.firstName ? 1 : -1,
            Cell: row => (
                <UserButton 
                    user={row.value}
                />
            ),
        },
        {
            Header: "Email",
            accessor: "email",
            sort: "desc"
        }
    ]

    if (!blockList) {

        tableColumns = [
            ...tableColumns,
            {
                Header: "Last Seen",
                accessor: "lastSeen",
                sort: "desc",
                Cell: row => (
                    <span>{moment(row.value * 1000).format("LL")}</span>
                )
    
            },
            {
                Header: "First Seen",
                accessor: "firstSeen",
                sort: "desc",
                Cell: row => (
                    <span>{moment(row.value * 1000).format("LL")}</span>
                )
            },
            {
                Header: "Actions",
                accessor: "actions",
                sortable: false,
                filterable: false
            }
        ]
    }

    return (
        <div>
            <ReactTable
            data={clients}
            filterable
            columns={tableColumns}
            defaultPageSize={10}
            showPaginationTop={false}
            showPaginationBottom={true}
            className="-highlight"
            />
        </div>

    );
}

export default ClientTable